import { Injectable } from '@angular/core';
import { ITax } from 'src/app/models/tax.model';
import { Provider } from '../provider';

@Injectable()
export class TaxService extends Provider<ITax>{
  protected url = "vocabularies/taxes";
}
